<template>
    <div>
        <h5 class="title" :class="{ bold }">{{ $t('talk.request.title') }}</h5>
        <div class="d-flex justify-content-between" :class="{ lg, md }">
            <div
                :id="`btn-talk-${category.id}-feedback`"
                v-for="category in categories"
                :key="category.id"
                class="d-flex category"
                :class="{ active: selected === category.id }"
                @click="selectCategory(category)"
            >
                <div
                    class="icon d-flex justify-content-center align-items-center"
                >
                    <improvement
                        v-if="category.id === 'improvement'"
                        color="#808080"
                    />
                    <positive
                        v-if="category.id === 'positive'"
                        color="#808080"
                    />
                </div>
                <div class="info">
                    <h5 class="category-name">
                        {{ category.name }}
                    </h5>
                    <span class="category-description">
                        {{ category.description }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Improvement, Positive } from './'

export default {
    name: 'CategorySelect',
    components: {
        Improvement,
        Positive,
    },
    props: {
        model: {
            type: String | null,
            default: null,
        },
        bold: {
            type: Boolean,
            default: false,
        },
        lg: {
            type: Boolean,
            default: true,
        },
        md: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            categories: [
                {
                    id: 'improvement',
                    name: this.$t('talk.request.improvement.name'),
                    description: this.$t(
                        'talk.request.improvement.description'
                    ),
                },
                {
                    id: 'positive',
                    name: this.$t('talk.request.positive.name'),
                    description: this.$t('talk.request.positive.description'),
                },
            ],
            selected: null,
        }
    },
    methods: {
        selectCategory(category) {
            this.selected = this.selected === category.id ? null : category.id
        },
    },
    watch: {
        selected() {
            this.$emit('update:model', this.selected)
        },
    },
}
</script>

<style lang="sass" scoped>
$darkBlue: #022B4F
$gray: #808080
.title
    font-size: 15px
    font-weight: 400
    margin-bottom: 10px
.bold
    font-weight: bold
    color: #6e6e6e

.lg
    width: 100%
.md
    width: 100%
    max-width: 600px

.category
    border: 1px solid $gray
    width: 49%
    border-radius: 5px
    cursor: pointer
    transition: 0.5s ease all
    .icon
        padding: 20px
        border-right: 1px solid $gray
        margin-right: 10px
        display: block
    .info
        padding: 5px
        color: $gray
        .category-name
            font-size: 15px
            margin-bottom: 5px
        .category-description
            font-size: 13px
            line-height: 1.1
            display: inline-block
    &:hover
        background-color: $darkBlue
        border-color: white
        .info
            color: white
        .icon
            border-color: white
            ::v-deep
                .icon
                    fill: white
.active
    background-color: $darkBlue
    border-color: white
    .info
        color: white
    .icon
        border-color: white
        ::v-deep
            .icon
                fill: white

@media (max-width: 768px)
    .lg,
    .md
        display: flex
        flex-direction: column
        align-items: center
        justify-content: space-around
        width: 100%
        .category
            margin-top: 10px
            width: 100%
</style>
